/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CsvUploadInput = {
    id: string;
    clientMutationId?: string | null;
};
export type csvUploadMutationVariables = {
    input: CsvUploadInput;
};
export type csvUploadMutationResponse = {
    readonly csvUpload: {
        readonly result: unknown | null;
    } | null;
};
export type csvUploadMutation = {
    readonly response: csvUploadMutationResponse;
    readonly variables: csvUploadMutationVariables;
};



/*
mutation csvUploadMutation(
  $input: CsvUploadInput!
) {
  csvUpload(input: $input) {
    result
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CsvUploadPayload",
    "kind": "LinkedField",
    "name": "csvUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "csvUploadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "csvUploadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "48a64f6c7d70fd0e612b474988f875df",
    "id": null,
    "metadata": {},
    "name": "csvUploadMutation",
    "operationKind": "mutation",
    "text": "mutation csvUploadMutation(\n  $input: CsvUploadInput!\n) {\n  csvUpload(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c6d81c5b169eec7b648aeb6381c2abb0';
export default node;
